export default "__VITE_ASSET__uR$tqFFI__"